import React, { createContext, useContext, useState } from "react"

interface CrudContextType<T> {
  openDialog: boolean
  setOpenDialog: (value: boolean) => void
  selectedRow: any
  setSelectedRow: (value: T) => void
}

const CrudContext = createContext<CrudContextType<any>>({
  openDialog: false,
  setOpenDialog: () => {},
  selectedRow: null,
  setSelectedRow: () => {},
})

export const CrudProvider = <T,>({
  children,
}: {
  children: React.ReactNode
}) => {
  const [openDialog, setOpenDialog] = useState(false)
  const [selectedRow, setSelectedRow] = useState<T | null>(null)

  return (
    <CrudContext.Provider
      value={{ openDialog, setOpenDialog, selectedRow, setSelectedRow }}
    >
      {children}
    </CrudContext.Provider>
  )
}

export function useCrudContext<T>() {
  return useContext(CrudContext) as CrudContextType<T>
}
